import type { IFinding, IFindingStatus } from '@/types/appsec/finding'
import type { ISeverity } from '@/types/severity'

export function getOccurrences({
  findings,
  severity,
  status,
  repository,
}: {
  findings: IFinding[]
  severity: ISeverity | null
  status: IFindingStatus | null
  repository?: string | null
}) {
  return findings
    .filter((f) => !f.repository || f.repository === repository || repository === null)
    .filter((f) => f.status === status || status === null)
    .filter((f) => f.severity === severity || severity === null)
    .map((f) => f.occurrences || 1)
    .reduce((acc, curr) => acc + curr, 0)
}
